export default {"src":"/_next/static/media/guests.ff18f9d5.svg","height":28,"width":30,"blurWidth":0,"blurHeight":0};